import { ref } from "vue";

export const currentlyOpenId = ref<string | null>(null);
